import { httpService } from '@/api/v1/http.service'
import { type DownloadParams, useDownload } from '@/hooks/useDownload'

import { type Params } from '../constants/timetable-events'

type TimetableDownloadParams = DownloadParams & Params

const useTimetableDownload = (
  timetableDownloadParams: TimetableDownloadParams
) =>
  useDownload({
    fileName: 'timetable',
    requestParams: timetableDownloadParams,
    // @ts-expect-error Waits for backend fix - file type should be returned
    downloadMutation: (params: TimetableDownloadParams) =>
      httpService.panel.panelTimetableEventsRetrieve(
        {
          format: params.format,
          class_id: params.classId,
          course_id: params.course,
          date_from: params.dateFrom,
          date_to: params.dateTo,
          room_id: params.room,
          student_id: params.student,
          teacher_id: params.teacher
        },
        { format: 'blob' }
      )
  })

export default useTimetableDownload
